const LoadList = () =>
  import(/* webpackChunkName: "load" */ '@/pages/load/list.vue')
const LoadSteps = () =>
  import(/* webpackChunkName: "load" */ '@/pages/load/steps.vue')
const LoadDetail = () =>
  import(/* webpackChunkName: "load" */ '@/pages/load/detail.vue')
const AllLoads = () =>
  import(/* webpackChunkName: "load" */ '@/pages/load/all.vue')
const LoadOffers = () =>
  import(/* webpackChunkName: "load" */ '@/pages/load/offers.vue')

export default {
  path: 'load',
  component: {
    name: 'LoadWrapper',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'LoadList',
      path: 'list',
      component: LoadList,
      meta: { title: 'nav.myLoads', layout: 'dashboard' }
    },
    {
      name: 'LoadOffers',
      path: 'offers',
      component: LoadOffers,
      meta: { title: 'nav.loadOffers', layout: 'dashboard' }
    },
    {
      name: 'AllLoads',
      path: 'all/:type',
      component: AllLoads,
      meta: { title: 'nav.allLoads{type}' },
      props: true
    },
    {
      name: 'LoadDetail',
      path: ':id',
      component: LoadDetail,
      meta: { title: 'nav.loadDetail' },
      props: true
    },
    {
      name: 'LoadSteps',
      path: ':id/steps',
      component: LoadSteps,
      meta: { title: 'nav.loadSteps' },
      props: true
    }
  ]
}
